export const paintedWeekStyles = {
  cell: 'bomdisoft-painted-week-cell',
  corner: 'bomdisoft-painted-week-corner',
  dayLabel: 'bomdisoft-painted-week-day-label',
  frame: 'bomdisoft-painted-week-frame',
  grid: 'bomdisoft-painted-week-grid',
  legend: 'bomdisoft-painted-week-legend',
  row: 'bomdisoft-painted-week-row',
  spans: 'bomdisoft-painted-week-spans',
  swatch: 'bomdisoft-painted-week-swatch',
  tick: 'bomdisoft-painted-week-tick',
} as const;
